import React from 'react'
import { Redirect, RouteChildrenProps, withRouter } from 'react-router'
import styled from 'styled-components'
import { AppRoutes, getRoute } from '../../AppRoutes'
import LawFirmNotAuthorized from './LawFirmNotAuthorized'

interface IStateProps {
  authorized: boolean
  hasLawFirm: boolean
}

const UnallowedContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`

const DiagramsUnallowed = (props: RouteChildrenProps<any, IStateProps>) =>
  props.location.state && !props.location.state.authorized ? (
    <UnallowedContainer>
      {!props.location.state.hasLawFirm && <Redirect to={getRoute(AppRoutes.LAW_FIRM)} />}
      {props.location.state.hasLawFirm && <LawFirmNotAuthorized />}
    </UnallowedContainer>
  ) : (
    <Redirect to={getRoute(AppRoutes.HOME)} />
  )

export default withRouter(DiagramsUnallowed)
